// import Cookies from 'universal-cookie'; 
import { getWithAuth } from './HttpRequest';
// import XLSX from 'xlsx';
// import { PERMISSION_LEVEL } from './Constant/enum';
// const cookies = new Cookies();

export function getPaginationQueryString(search, currentPageNumber, pageSize, sort) {
    let queryString = [];
    let query = {};
    if (search) {
        query["q"] = search;
    }
    if (currentPageNumber) {
        query["page"] = currentPageNumber;
    }
    if (pageSize) {
        query["size"] = pageSize;
    }
    if (sort) {
        query["sort"] = sort;
    }
    return queryString = Object.keys(query)
        .map((v, i) => `${encodeURIComponent(v)}=${encodeURIComponent(query[v])}`)
        .join('&');
}
// export function setTokenCookie(token) {
//     cookies.set('token', token, { path: '/' });
// }
export function tokenVerified() {
    let user = JSON.parse((localStorage.getItem('userData')));
    deleteUserData();
    user.inAppOtpEnabled = false;
    setUserData(user);
}
// export function getTokenCookie() {
//     return cookies.get('token');
// }
// export function deleteTokenCookie() {

//     cookies.remove('token', { path: '/' });
// }
export function setUserData(userData) {
    localStorage.setItem('userData', JSON.stringify(userData));
}
export function getUserData() {
    return localStorage.getItem('userData');
}
export function getUserType() {
    return JSON.parse((localStorage.getItem('userData')))?.type;
}
export function getEmployeeId() {
    return JSON.parse((localStorage.getItem('userData')))?.empId;
}
export function isEmployee() {
    return getEmployeeId() != null && getEmployeeId() != 0;
}
export function getUserName() {
    return JSON.parse((localStorage.getItem('userData')))?.name;
}
export function getOtpRequired() {
    return JSON.parse((localStorage.getItem('userData')))?.inAppOtpEnabled;
}
export function getUserTitleName() {
    return JSON.parse((localStorage.getItem('userData')))?.designation;
}
export function getProfilePicture() {
    return JSON.parse((localStorage.getItem('userData')))?.profilePicture || "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";
}
export function getDefaultProfilePicture() {
    return "data:image/jpeg;base64,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";
}
export function deleteUserData() {
    localStorage.removeItem('userData');
}
export function getCurrency() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.currencySymbol || "$";
}
export function getTitle() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.titleText || "WorkPlus";
}
export function getLogo() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.logo;
}
export function getFavIcon() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.favicon;
}
export function getCompanyId() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.companyId || 0;
}
export function getPrimaryColor() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.primaryColor || "#11e26e";
}
export function getPasswordPolicy() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.passwordPolicy || "";
}
export function getPasswordValidationMessage() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.passwordValidationMessage || "Invalid Password";
}
export function getMenuBgColor() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.menuBg || "#34444c";
}
export function getPrimaryGradientColor() {
    return JSON.parse((localStorage.getItem('userData')))?.companySetting?.gradientColor || "#30870a";
}
export function setCompanySetting(companySetting) {
    var tmpData = JSON.parse(localStorage.getItem('userData'));
    if (tmpData) {
        tmpData.companySetting.primaryColor = companySetting.primaryColor;
        tmpData.companySetting.menuBg = companySetting.menuBg;
        tmpData.companySetting.gradientColor = companySetting.gradientColor;
        tmpData.companySetting.titleText = companySetting.titleText;
        setUserData(tmpData);
    }

}

export function getReadableDate(date) {
    if (!date) {
        return "";
    }
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
}

export function getCustomizedDate(date) {
    if (!date) {
        return "";
    }
    var d = new Date(date);

    const formattedDate = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

    return formattedDate;
}

export function isDateGreaterThanOrEqualsToCurrentDate(date) {

    var resDate1 = new Date(
        new Date(date).getFullYear(),
        new Date(date).getMonth(),
        new Date(date).getDate());

    var resDate2 = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate());

}
export function camelize(text) {
    var result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}

// export function exportToCsv(data, sheetName, fileName) {
//     let Heading = [];
//     Heading.push(Object.keys(data[0]).map(key => camelize(key)));
//     const wb = XLSX.utils.book_new();
//     const ws = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_aoa(ws, Heading);
//     XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });
//     XLSX.utils.book_append_sheet(wb, ws, sheetName);
//     XLSX.writeFile(wb, fileName + '.xlsx');
// }
export function toLocalTime(time) {
    if (time) {
        return new Date('01/01/2022 ' + time + ' UTC').toLocaleTimeString([], { timeStyle: 'short' });
    }
}
export function toLocalCalendarTime(time) {
    if (time) {
        return (new Date('01/01/2022 ' + time + ' UTC').toLocaleTimeString([], { timeStyle: 'medium', hourCycle: 'h24' })).split(" ")[0];
    }
}

export function toUTCCalendarTime(time) {
    if (time) {
        var date = new Date('01/01/2022 ' + time);
        return ("0" + date.getUTCHours()).slice(-2) + ":" + ("0" + date.getUTCMinutes()).slice(-2) + ":00";
    }
}
export function toLocalDate(date) {
    if (date) {
        return new Date(date + ' UTC').toLocaleDateString();
    }
}
export function toLocalDateTime(dateTime) {
    if (dateTime) {
        dateTime = dateTime.replace('T', ' ');
        return new Date(dateTime + ' UTC').toLocaleString([], { timeStyle: 'short', dateStyle: 'medium', hourCycle: 'h12' });

    }
}
export function formTime(time) {
    if (time) {
        return new Date('01/01/2022 ' + time + ' UTC').toLocaleTimeString().slice(0, -3);
    }
}

export function permissionCheck(response) {
    if (response.status == "LOCKED" || response.message == "Invalid Permission" || response.message == "You are not authorized to perform this action") {
        console.log(response)
        window.location.pathname = '/access-denied';
        return false;
    }
    return true;
}

// export function getPermission(module, actionType) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return PERMISSION_LEVEL.ORGANIZATION;
//     }
//     var roleActionEntities = JSON.parse((localStorage.getItem('userData')))?.role?.roleActionEntities;
//     if (roleActionEntities) {
//         var moduleRoleActions = roleActionEntities.filter(a => a.module.toLowerCase() == module.toLowerCase() && a.actionType == actionType);
//         if (moduleRoleActions.filter(r => r.permissionLevel == PERMISSION_LEVEL.ORGANIZATION).length > 0) {
//             return PERMISSION_LEVEL.ORGANIZATION;
//         } else if (moduleRoleActions.filter(r => r.permissionLevel == PERMISSION_LEVEL.HIERARCHY).length > 0) {
//             return PERMISSION_LEVEL.HIERARCHY;
//         } else if (moduleRoleActions.filter(r => r.permissionLevel == PERMISSION_LEVEL.SELF).length > 0) {
//             return PERMISSION_LEVEL.SELF;
//         }
//     }
//     return PERMISSION_LEVEL.NONE;
// }
// export function getSelfPermission(module, actionType) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return PERMISSION_LEVEL.ORGANIZATION;
//     }
//     var roleActionEntities = JSON.parse((localStorage.getItem('userData')))?.role?.roleActionEntities;
//     if (roleActionEntities) {
//         var moduleRoleActions = roleActionEntities.filter(a => a.module.toLowerCase() == module.toLowerCase() && a.actionType == actionType);
//         if (moduleRoleActions.filter(r => r.permissionLevel == PERMISSION_LEVEL.SELF).length > 0) {
//             return PERMISSION_LEVEL.SELF;
//         }
//     }
//     return PERMISSION_LEVEL.NONE;
// }

// export function verifyViewPermission(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     return getPermission(module, "VIEW") != PERMISSION_LEVEL.NONE;
// }
// export function verifySelfViewPermission(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     return getSelfPermission(module, "VIEW") != PERMISSION_LEVEL.NONE;
// }
// export function verifySelfEditPermission(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     return getSelfPermission(module, "EDIT") != PERMISSION_LEVEL.NONE;
// }
// export function verifyEditPermission(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     return getPermission(module, "EDIT") != PERMISSION_LEVEL.NONE;
// }

// export function verifyApprovalPermission(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     var permission = getPermission(module, "EDIT");
//     return permission == PERMISSION_LEVEL.ORGANIZATION || permission == PERMISSION_LEVEL.HIERARCHY;
// }
// export function verifyViewPermissionForTeam(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     var permission = getPermission(module, "VIEW");
//     return permission == PERMISSION_LEVEL.ORGANIZATION || permission == PERMISSION_LEVEL.HIERARCHY;
// }
// export function verifyOrgLevelViewPermission(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     return getPermission(module, "VIEW") == PERMISSION_LEVEL.ORGANIZATION;
// }
// export function verifyOrgLevelEditPermission(module) {
//     if (getUserType() == 'COMPANY_ADMIN') {
//         return true;
//     }
//     return getPermission(module, "EDIT") == PERMISSION_LEVEL.ORGANIZATION;
// }